module.exports = __webpack_public_path__ + "static/fonts/Raleway-Medium.2ec85574.ttf";